export const SchoolStatuses = {
  ACCOUNTCREATED: "accountcreated",
  WAITINGFORAPPROVAL: "waitingforapproval",
  ENABLED: "enabled",
  ARCHIVED: "archived",
  REMOVED: "removed"
};
